import { render, staticRenderFns } from "./ViewEmail.vue?vue&type=template&id=a15bbf5e"
import script from "./ViewEmail.vue?vue&type=script&lang=js"
export * from "./ViewEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports